import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LuX } from 'react-icons/lu';
import CategoryDetail from './CategoryDetail';

// Mobile category-detail modal — wraps CategoryDetail in a bottom-anchored
// sheet. Used when a category is selected from the FACE BREAKDOWN on mobile.

const CategoryDetailModal = ({ open, onClose, categoryKey, score, summary, subScores, subNotes }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        className="fixed inset-0 z-[80] flex items-end sm:items-center justify-center backdrop-blur-md"
        style={{ background: 'rgba(0,0,0,0.6)' }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.2 }}
        onClick={onClose}
        role="dialog"
        aria-modal="true"
        aria-label="Category detail"
      >
        <motion.div
          className="relative w-full sm:max-w-lg max-h-[88vh] overflow-y-auto rounded-t-card sm:rounded-card"
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 40, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 320, damping: 30 }}
          onClick={(e) => e.stopPropagation()}
        >
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="absolute top-4 right-4 z-10 w-9 h-9 rounded-full bg-[#232322] border border-hairline-soft flex items-center justify-center text-bone cursor-pointer"
          >
            <LuX size={16} />
          </button>
          <CategoryDetail
            className="pt-14"
            categoryKey={categoryKey}
            score={score}
            summary={summary}
            subScores={subScores}
            subNotes={subNotes}
          />
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default CategoryDetailModal;
